export default {
  facebook: require(`./facebook.png`).default,
  instagram: require(`./instagram.png`).default,
  linkedin: require(`./linkedin.png`).default,
  youtube: require(`./youtube.png`).default,
};
